import React from 'react';
import { useParams } from 'react-router-dom';
import FadeIn from 'react-fade-in';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Page from 'src/components/Page';
import { useTranslation } from 'react-i18next';
import InvestorTabs from './InvestorTabs';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  preloaderCard: {
    height: '82vh'
  }
}));

const InvestorDetail = () => {
  const { classes } = useStyles();
  const { id } = useParams();
  const { t } = useTranslation();

  return (
    <Page
      className={classes.root}
      title={`${t('NAVIGATION.INVESTOR')} ${id ?? ''}`}
    >
      <FadeIn transitionDuration={300}>
        <Container maxWidth={false}>
          <Box>
            <InvestorTabs />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default InvestorDetail;
